import { CSSProperties } from "react";

export const styles: { [key: string]: CSSProperties } = {
  container: {
    width: "100vw",
    maxWidth: "100%",
    height: "100vh",
    backgroundColor: "#f5f5f5",
    padding: 5,
    boxSizing: "border-box",
    overflowY: "auto",
  },
  title: {
    marginBottom: 2,
  },
  lisencebox: {
    width: "98%",
    padding: "8px 16px",
    borderRadius: 2,
    backgroundColor: "#fff",
  },
  viewbox: {
    justifyContent: "space-between",
    alignItems: "center",
  },
  button: {
    padding: 0,
  },
  lisenceText: {
    whiteSpace: "pre-wrap",
    fontSize: 10,
  },
};
